import { takeLatest, call, put, all } from 'redux-saga/effects'
import actionTypes from '../../actions/actionTypes'
import createApiCall, { apiURL } from '../../apis/wpApi/endpoints'
import authUser from '../../apis/wpApi/authUser'
import watchSocialMediaDownload from './watchSocialMediaDownload'

const getPresetsCall = () => createApiCall({
    url:          apiURL.SOCIAL_PRESETS_GET,
    method:       'GET',
    headerParams: { token: authUser.getToken() },
})

const createPresetCall = (data) => createApiCall({
    url:          apiURL.SOCIAL_PRESET_CREATE,
    method:       'POST',
    data,
    headerParams: { token: authUser.getToken() },
})

const updatePresetCall = (data) => createApiCall({
    url:          apiURL.SOCIAL_PRESET_UPDATE,
    method:       'POST',
    data,
    headerParams: { token: authUser.getToken() },
})

const deletePresetCall = (id) => createApiCall({
    url:          apiURL.SOCIAL_PRESET_DELETE,
    method:       'POST',
    data:         { id },
    headerParams: { token: authUser.getToken() },
})

function* watchPresetsGet() {
    yield takeLatest(actionTypes.SOCIAL_MEDIA_PRESETS_GET_REQUEST, function*() {
        try {
            const response = yield call(getPresetsCall)
            yield put({
                type:    actionTypes.SOCIAL_MEDIA_PRESETS_GET_SUCCESS,
                payload: response.data,
            })
        } catch (e) {
            yield put({
                type:    actionTypes.SOCIAL_MEDIA_PRESETS_GET_ERROR,
                payload: e.message,
            })
        }
    })
}

function* watchPresetCreate() {
    yield takeLatest(actionTypes.SOCIAL_MEDIA_PRESET_CREATE_REQUEST, function*(action) {
        try {
            const response = yield call(createPresetCall, action.payload)
            yield put({
                type:    actionTypes.SOCIAL_MEDIA_PRESET_CREATE_SUCCESS,
                payload: response.data,
            })
        } catch (e) {
            yield put({
                type:    actionTypes.SOCIAL_MEDIA_PRESET_CREATE_ERROR,
                payload: e.message,
            })
        }
    })
}

function* watchPresetUpdate() {
    yield takeLatest(actionTypes.SOCIAL_MEDIA_PRESET_UPDATE_REQUEST, function*(action) {
        try {
            const response = yield call(updatePresetCall, action.payload)
            yield put({
                type:    actionTypes.SOCIAL_MEDIA_PRESET_UPDATE_SUCCESS,
                payload: response.data,
            })
        } catch (e) {
            yield put({
                type:    actionTypes.SOCIAL_MEDIA_PRESET_UPDATE_ERROR,
                payload: e.message,
            })
        }
    })
}

function* watchPresetDelete() {
    yield takeLatest(actionTypes.SOCIAL_MEDIA_PRESET_DELETE_REQUEST, function*(action) {
        try {
            yield call(deletePresetCall, action.payload.id)
            yield put({
                type:    actionTypes.SOCIAL_MEDIA_PRESET_DELETE_SUCCESS,
                payload: { id: action.payload.id },
            })
        } catch (e) {
            yield put({
                type:    actionTypes.SOCIAL_MEDIA_PRESET_DELETE_ERROR,
                payload: e.message,
            })
        }
    })
}

export default function* socialMediaSaga() {
    yield all([
        watchPresetsGet(),
        watchPresetCreate(),
        watchPresetUpdate(),
        watchPresetDelete(),
        watchSocialMediaDownload(),
    ])
}
